import React from "react";
import CategoryPage from "./CategoryPage";

function InkAndEchoArticles({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Articles"
      parentCategory="Articles"
      subcategoryValues={[
        "Ink and Echo"
      ]}
      subSubcategoryValues={[
        "Articles"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default InkAndEchoArticles;